import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import allowedUserIds from "../pages/admin/adminConfig";
import sessionIcon from "../assets/images/session.svg";
import clientIcon from "../assets/images/client.svg";
import helpIcon from "../assets/images/help.svg";
import shieldIcon from "../assets/images/shield.svg";
import houseIcon from "../assets/images/house.svg";
import learningIcon from "../assets/images/mortarboard.svg";

const TherapistSidebar = ({
  activeNavItem,
  setActiveNavItem,
  sidebarCollapsed,
  setSidebarCollapsed,
  learningSubsections = [],
  selectedLearningSectionId,
  onSelectLearningSection,
}) => {
  const navigate = useNavigate();
  const { PlutonicuserID } = useContext(AuthContext);
  const isAdmin = allowedUserIds.includes(PlutonicuserID);
  return (
    <div
      className={`fixed left-0 top-[83px] h-[calc(100vh-83px)] bg-gray-100 transition-all duration-300 z-40 ${
        sidebarCollapsed ? "w-16" : "w-64"
      }`}
    >
      <button
        onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
        className="absolute -right-3 top-6 bg-white border border-gray-300 rounded-full w-6 h-6 flex items-center justify-center text-gray-600 hover:bg-gray-50 shadow-sm"
      >
        <svg
          className={`w-3 h-3 transition-transform duration-300 ${
            sidebarCollapsed ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>

      <div className="pt-6">
          {/* Home */}
  <div
    className={`flex items-center px-6 py-3 cursor-pointer transition-colors ${
      activeNavItem === "home"
        ? "bg-blue-100 text-blue-600 border-r-3 border-blue-600"
        : "text-gray-700 hover:bg-gray-200"
    }`}
    onClick={() => {
      setActiveNavItem("home");
    }}
  >
    <img
      src={houseIcon}
      alt="home"
      className={`${sidebarCollapsed ? "w-8 h-8" : "mr-3 w-5 h-5"}`}
    />
    {!sidebarCollapsed && <span className="font-medium">Home</span>}
  </div>


        <div
          className={`flex items-center px-6 py-3 cursor-pointer transition-colors ${
            activeNavItem === "sessions"
              ? "bg-blue-100 text-blue-600 border-r-3 border-blue-600"
              : "text-gray-700 hover:bg-gray-200"
          }`}
          onClick={() => {
            window.location.assign("https://mobiledev.plutonichealth.co/");
          }}
        >
          <img
            src={sessionIcon}
            alt="sessions"
            className={`${sidebarCollapsed ? "w-8 h-8" : "mr-3 w-5 h-5"}`}
          />
          {!sidebarCollapsed && <span className="font-medium">Sessions</span>}
        </div>

        <div
          className={`flex items-center px-6 py-3 cursor-pointer transition-colors ${
            activeNavItem === "clients"
              ? "bg-blue-100 text-blue-600 border-r-3 border-blue-600"
              : "text-gray-700 hover:bg-gray-200"
          }`}
          onClick={() => {
            setActiveNavItem("clients");
            navigate("/clients");
          }}
        >
          <img
            src={clientIcon}
            alt="clients"
            className={`${sidebarCollapsed ? "w-8 h-8" : "mr-3 w-5 h-5"}`}
          />
          {!sidebarCollapsed && <span className="font-medium">Clients</span>}
        </div>
        

        <div
  className={`flex items-center px-6 py-3 cursor-pointer transition-colors ${
    activeNavItem === "help"
      ? "bg-blue-100 text-blue-600 border-r-3 border-blue-600"
      : "text-gray-700 hover:bg-gray-200"
  }`}
  onClick={() => {
    setActiveNavItem("help");
  }}
>
  <img
    src={helpIcon}
    alt="help"
    className={`${sidebarCollapsed ? "w-8 h-8" : "mr-3 w-5 h-5"}`}
  />
  {!sidebarCollapsed && (
    <span className="font-medium">Help Center</span>
  )}
</div>


      <div
        className={`flex items-center px-6 py-3 cursor-pointer transition-colors ${
          activeNavItem === "learning"
            ? "bg-blue-100 text-blue-600 border-r-3 border-blue-600"
            : "text-gray-700 hover:bg-gray-200"
        }`}
        onClick={() => {
          setActiveNavItem("learning");
        }}
      >
        <img
          src={learningIcon}
          alt="learning"
          className={`${sidebarCollapsed ? "w-8 h-8" : "mr-3 w-5 h-5"}`}
        />
        {!sidebarCollapsed && <span className="font-medium">Learning Center</span>}
      </div>
      {activeNavItem === "learning" && !sidebarCollapsed && (
        <div className="pb-1 pl-14 pr-3">
          {learningSubsections.map((section) => (
            <button
              key={section.id}
              type="button"
              onClick={() => onSelectLearningSection(section)}
              className={`block w-full truncate py-1.5 text-left text-sm transition-colors hover:text-blue-600 ${
                selectedLearningSectionId === section.id
                  ? "text-blue-500"
                  : "text-gray-700"
              }`}
              title={section.cardTitle || section.title}
            >
              {section.cardTitle || section.title}
            </button>
          ))}
        </div>
      )}

      <div
        className={`flex items-center px-6 py-3 cursor-pointer transition-colors ${
          activeNavItem === "policies"
            ? "bg-blue-100 text-blue-600 border-r-3 border-blue-600"
            : "text-gray-700 hover:bg-gray-200"
        }`}
        onClick={() => {
          setActiveNavItem("policies");
        }}
      >
        <img
          src={shieldIcon}
          alt="policies"
          className={`${sidebarCollapsed ? "w-8 h-8" : "mr-3 w-5 h-5"}`}
        />
        {!sidebarCollapsed && <span className="font-medium">Policies</span>}
      </div>

        {isAdmin && (
          <div
            className={`flex items-center px-6 py-3 cursor-pointer transition-colors ${
              activeNavItem === "ai-dev-test"
                ? "bg-red-100 text-red-600 border-r-3 border-red-600"
                : "text-gray-700 hover:bg-gray-200"
            }`}
            onClick={() => {
              setActiveNavItem("ai-dev-test");
              navigate("/ai-dev-test");
            }}
          >
            <svg
              className={`${sidebarCollapsed ? "w-8 h-8" : "mr-3 w-5 h-5"}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            {!sidebarCollapsed && (
              <span className="font-medium">AI Dev Test</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TherapistSidebar;
